import Trigger from 'eflex/models/trigger';
import { anyInvalid } from 'eflex/util/getter-helpers';
import { hasMany, attr } from '@ember-data/model';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';
import { checkMqttTopicUnique } from 'eflex/util/validators';

@buildValidations({
  mqttTopic: [
    validator('inline', {
      validate(mqttTopic, options, nodeRedTriggerj) {
        return checkMqttTopicUnique(nodeRedTriggerj);
      },
    }),
    validator('presence', true),
  ],
})
class NodeRedTrigger extends Trigger {
  @attr('string') mqttTopic;

  @hasMany('variable-def', { async: false, inverse: null, embedded: true }) variableDefs;

  get isDirty() {
    return super.isDirty || this.variableDefs.some(item => item.isDirty);
  }

  get variableDefsInvalid() {
    return anyInvalid(this.variableDefs);
  }

  get isSelfOrChildInvalid() {
    return this.isInvalid || this.vvariableDefsInvalid;
  }

  get validatedRelationships() {
    return ['variableDefs'];
  }

  get copyableOptions() {
    const options = super.copyableOptions;
    options.ignoreAttributes.add('variableDefs');
    return options;
  }
}

export default NodeRedTrigger;
